import { ReviewFeedbackCriticality, ReviewFeedbackType, } from 'shared/domains/apollo/generated/types';
export const progressTypeMap = {
    [ReviewFeedbackCriticality.Critical]: 'critical',
    [ReviewFeedbackCriticality.Notable]: 'notable',
    [ReviewFeedbackCriticality.Minor]: 'minor',
    [ReviewFeedbackType.Approved]: 'approved',
};
